import { render, staticRenderFns } from "./RegMalariaAdd.vue?vue&type=template&id=342d0903&scoped=true"
import script from "./RegMalariaAdd.vue?vue&type=script&lang=js"
export * from "./RegMalariaAdd.vue?vue&type=script&lang=js"
import style0 from "./RegMalariaAdd.vue?vue&type=style&index=0&id=342d0903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342d0903",
  null
  
)

export default component.exports